module.exports = __webpack_public_path__ + "static/media/About_Advicing.ee0f9a33.svg";